import $ from 'jquery';

$(function() {
    var contactPrefValue = null;
    // Get the radio buttons and the submit button
    var contactPrefRadios = $("input.cwm-contact-pref-comp__radio--input[name='optionsRadios']");
    var contactPrefSubmit = $("#contactPrefSave");

    // Disable the submit button initially
    contactPrefSubmit.prop("disabled", true);

    // Add a change event handler for the radio buttons
    contactPrefRadios.change(function(){
        contactPrefSubmit.prop("disabled", false);
    });
    
    contactPrefSubmit.on( "click", function() {
        // Send the value of the radio button to the database using ajax
        contactPrefValue = {
            DoNotEmail: contactPrefRadios.filter(":checked").val()
        };
        // Add a click event handler for the form save
        $("#contactPref_form").validate({
            submitHandler: function(form) {
                $.ajax({ 
                    url: form.action,
                    type: form.method,
                    data: contactPrefValue,
                    dataType: "json", 
                        error:function() {
                            $(".cwm-status-msg__container.contact-pref-status-msg.status-error").css('display', 'flex').delay(3000).queue(function(n) {
                                $(this).hide(); n();
                            });
                        },
                        success: function(data) {                          
                            $(".cwm-status-msg__container.contact-pref-status-msg.status-success").css('display', 'flex').delay(3000).queue(function(n) {
                                $(this).hide(); n();
                                contactPrefSubmit.prop("disabled", true);
                            });
                            $('html,body').animate({
                                scrollTop: $(".cwm-status-msg__container.contact-pref-status-msg").offset().top - 300},'1000');
                         
                        },
                });
            } 
        })
    });
    
});


// WEBPACK FOOTER //
// ./components/cwm-contact-preferences/scripts/cwm-contact-preferences.js